<template>
  <div class="content-dashboard">
    <template v-if="mode === 'simple'">
      <div class="d-flex align-items-center justify-content-between">
        <h3>{{ $t("informations_personnelles.title") }}</h3>

        <button class="btn btn-outline-orange" @click="mode = 'modifier'">
          {{ $t("informations_personnelles.buttons.edit") }}
        </button>
      </div>

      <div class="row mt-3">
        <div class="col-lg-12">
          <div class="box-chart mb-3 w-100">
            <h4>{{ $t("informations_personnelles.sections.detailed_info") }}</h4>

            <div class="row mt-3">
              <div class="col-lg-6">
                <div class="form-input">
                  <label for="name">{{ $t("informations_personnelles.labels.clinic_name") }}</label>
                  <input type="text" class="form-control" id="name" v-model="veterinaire.lastName" disabled required />
                </div>
              </div>

              <div class="col-lg-6">
                <div class="form-input">
                  <label for="email">{{ $t("informations_personnelles.labels.professional_email") }}</label>
                  <input type="email" class="form-control" id="email" v-model="veterinaire.email" disabled required />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6">
                <div class="form-input">
                  <label for="phone">{{ $t("informations_personnelles.labels.phone_number") }}</label>
                  <div class="input-group">
                    <select
                      class="form-select telephone-select"
                      :value="parsedVeterinairePhone.indicatifPhoneNumber"
                      disabled
                    >
                      <option
                        v-for="country in countryDialCodes"
                        :key="country.code"
                        :value="country.dialCode"
                      >
                        {{ country.displayCode }} {{ country.code }}
                      </option>
                    </select>
                    <input
                      type="tel"
                      class="form-control telephone-input"
                      id="phone"
                      :value="parsedVeterinairePhone.number"
                      disabled
                      required
                    />
                  </div>
                </div>
              </div>


              <div class="col-lg-6">
                <div class="form-input">
                  <label for="adresse">{{ $t("informations_personnelles.labels.billing_address") }}</label>
                  <input
                    type="text"
                    class="form-control"
                    id="adresse"
                    :value="veterinaire.adressesFacturation 
                    ? `${veterinaire.adressesFacturation.street}, ${veterinaire.adressesFacturation.postcode} ${veterinaire.adressesFacturation.city}`
                    : ''"
                    disabled
                    required
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="box-chart mb-3 w-100">
            <h4>{{ $t("informations_personnelles.sections.detailed_info") }}</h4>

            <div class="row mt-3">
              <div class="col-lg-6">
                <div class="form-input">
                  <label for="numero">{{ $t("informations_personnelles.labels.siret_number") }}</label>
                  <input type="text" class="form-control" id="numero" v-model="veterinaire.siret" disabled required />
                </div>
              </div>
            </div>
          </div>

          <div class="box-chart w-100">
            <h4>{{ $t("informations_personnelles.sections.security") }}</h4>

            <div class="row mt-3">
              <div class="col-lg-9">
                <div class="form-input">
                  <label for="pwd">{{ $t("informations_personnelles.labels.password") }}</label>
                  <div class="d-flex align-items-center w-100 gap-2">
                    <input
                      type="password"
                      class="form-control"
                      id="pwd"
                      v-model="dataPassword.newPassword"
                      :placeholder="$t('informations_personnelles.placeholders.password')"
                      required
                    />
                    <a class="w-50" href="" @click.prevent="openChangePasswordModal">{{
                      $t("informations_personnelles.buttons.change_password")
                    }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="row justify-content-center mt-4">
        <div class="col-lg-3">
          <button class="btn btn-orange w-100" @click.prevent="UpdateInfo" id="send">
            {{ $t("informations_personnelles.buttons.save") }}
          </button>
        </div>
      </div> -->
      <div v-if="successEnvoiMessage" class="alert alert-success mt-4 w-50 content-centered">
        <span class="success-message">{{ successEnvoiMessage }}</span>
      </div>
      <div v-if="errorEnvoiMessage" class="alert alert-danger mt-4 w-50 content-centered">
        <span class="error-message">{{ errorEnvoiMessage }}</span>
      </div>
    </template>
    <template v-else>
      <div class="d-flex gap-2">
        <span class="back-link cursor-pointer" @click="mode = 'simple'"
          ><i class="ti ti-back-left font-20 orange-color pe-2"></i
        ></span>

        <h3>{{ $t("informations_personnelles.edit_title") }}</h3>
      </div>
      <div class="check-element mt-4">
        <h4 class="font-16 blue-color mb-3">{{ $t("contact.sections.modification_elements") }}</h4>

        <div class="d-flex gap-4">
          <div class="custom-checkbox">
            <label>
              <input type="checkbox" v-model="form.update_billing_address" />
              {{ $t("contact.checkboxes.billing_address") }}</label
            >
          </div>
          <div class="custom-checkbox">
            <label>
              <input type="checkbox" v-model="form.update_delivery_address" />
              {{ $t("contact.checkboxes.delivery_address") }}</label
            >
          </div>
          <div class="custom-checkbox">
            <label> <input type="checkbox" v-model="form.update_email" /> {{ $t("contact.checkboxes.email") }}</label>
          </div>
          <div class="custom-checkbox">
            <label> <input type="checkbox" v-model="form.update_phone" /> {{ $t("contact.checkboxes.phone") }}</label>
          </div>
          <div class="custom-checkbox">
            <label>
              <input type="checkbox" v-model="form.update_lastname" /> {{ $t("contact.checkboxes.lastname") }}</label
            >
          </div>

          <div class="custom-checkbox">
            <label>
              <input type="checkbox" v-model="form.update_firstname" /> {{ $t("contact.checkboxes.firstname") }}</label
            >
          </div>
          <div class="custom-checkbox">
            <label> <input type="checkbox" v-model="form.update_clinic_name" /> Nom de la clinique</label>
          </div>
        </div>
      </div>

      <div class="form-block">
        <div class="row">
          <div class="col-lg-6">
            <div class="form-input">
              <label class="label-control">{{ $t("informations_personnelles.labels.subject") }}</label>
              <input type="text" class="form-control" v-model="form.sujet" disabled />
            </div>
          </div>
        </div>

        <div v-if="form.update_billing_address">
          <h5 class="blue-color font-bold font-16 mt-5 mb-4">
            {{ $t("informations_personnelles.sections.billing_address") }}
          </h5>

          <div class="row">
            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">{{ $t("informations_personnelles.labels.address") }}</label>
                <input type="text" class="form-control" v-model="form.update_billing_address_address" />
                <span v-if="errorDemandeAdressFacturation" class="error-message mb-1">{{
                  errorDemandeAdressFacturation
                }}</span>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">{{ $t("informations_personnelles.labels.address2") }}</label>
                <input type="text" class="form-control" v-model="form.update_billing_address_address2" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">{{ $t("informations_personnelles.labels.address3") }}</label>
                <input type="text" class="form-control" v-model="form.update_billing_address_address3" />
              </div>
            </div>

            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">{{ $t("informations_personnelles.labels.postal_code") }}</label>
                <input type="text" class="form-control" v-model="form.update_billing_address_postcode" v-only-digits />
                <span v-if="errorDemandeCodePostalFacturation" class="error-message mb-1">{{
                  errorDemandeCodePostalFacturation
                }}</span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">{{ $t("informations_personnelles.labels.city") }}</label>
                <input type="text" class="form-control" v-model="form.update_billing_address_city" />
                <span v-if="errorDemandeVilleFacturation" class="error-message mb-1">{{
                  errorDemandeVilleFacturation
                }}</span>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">{{ $t("informations_personnelles.labels.country") }}</label>
                <input type="text" class="form-control" v-model="form.update_billing_address_pays" />
                <span v-if="errorDemandePaysFacturation" class="error-message mb-1">{{
                  errorDemandePaysFacturation
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="form.update_delivery_address">
          <h5 class="blue-color font-bold font-16 mt-5 mb-4">
            {{ $t("informations_personnelles.sections.delivery_address") }}
          </h5>

          <div class="row">
            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">{{ $t("informations_personnelles.labels.address") }}</label>
                <input type="text" class="form-control" v-model="form.update_delivery_address_address" />
                <span v-if="errorDemandeAdressLivraison" class="error-message mb-1">{{
                  errorDemandeAdressLivraison
                }}</span>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">{{ $t("informations_personnelles.labels.address2") }}</label>
                <input type="text" class="form-control" v-model="form.update_delivery_address_address2" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">{{ $t("informations_personnelles.labels.address3") }}</label>
                <input type="text" class="form-control" v-model="form.update_delivery_address_address3" />
              </div>
            </div>

            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">{{ $t("informations_personnelles.labels.postal_code") }}</label>
                <input type="text" class="form-control" v-model="form.update_delivery_address_postcode" v-only-digits />
                <span v-if="errorDemandeCodePostalLivraison" class="error-message mb-1">{{
                  errorDemandeCodePostalLivraison
                }}</span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">{{ $t("informations_personnelles.labels.city") }}</label>
                <input type="text" class="form-control" v-model="form.update_delivery_address_city" />
                <span v-if="errorDemandeVilleLivraison" class="error-message mb-1">{{
                  errorDemandeVilleLivraison
                }}</span>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">{{ $t("informations_personnelles.labels.country") }}</label>
                <input type="text" class="form-control" v-model="form.update_delivery_address_pays" />
                <span v-if="errorDemandePaysLivraison" class="error-message mb-1">{{ errorDemandePaysLivraison }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="form.update_email">
          <div class="row">
            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">{{ $t("informations_personnelles.labels.email") }}</label>
                <input type="email" class="form-control" v-model="form.update_email_email" />
                <span v-if="errorDemandeEmail" class="error-message mb-1">{{ errorDemandeEmail }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="form.update_phone">
          <div class="row">
            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">{{ $t("informations_personnelles.labels.phone") }}</label>
                <div class="input-group">
                  <select
                    class="form-select telephone-select"
                    v-model="form.indicatifPhoneNumber"
                  >
                    <option
                      v-for="country in countryDialCodes"
                      :key="country.code"
                      :value="country.dialCode"
                    >
                      {{ country.displayCode }} {{ country.code }}
                    </option>
                  </select>
                  <input type="text" class="form-control telephone-input" v-model="form.update_phone_phone" v-only-digits />
                </div>
                <span v-if="errorDemandePhone" class="error-message mb-1">{{ errorDemandePhone }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="form.update_lastname">
          <div class="row">
            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">{{ $t("informations_personnelles.labels.lastname") }}</label>
                <input type="text" class="form-control" v-model="form.update_lastname_lastname" />
                <span v-if="errorDemandeNom" class="error-message mb-1">{{ errorDemandeNom }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="form.update_firstname">
          <div class="row">
            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">{{ $t("informations_personnelles.labels.firstname") }}</label>
                <input type="text" class="form-control" v-model="form.update_firstname_firstname" />
                <span v-if="errorDemandePrenom" class="error-message mb-1">{{ errorDemandePrenom }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="form.update_clinic_name">
          <div class="row">
            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">Nom de la clinique</label>
                <input type="text" class="form-control" v-model="form.update_clinic_name_value" />
                <span v-if="errorDemandeNomClinique" class="error-message mb-1">{{ errorDemandeNomClinique }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-lg-12">
            <div class="form-input">
              <label class="label-control">{{ $t("informations_personnelles.labels.message") }}</label>
              <textarea class="form-control round-15" rows="7" v-model="form.message"></textarea>
              <span v-if="errorDemandeMessage" class="error-message mb-1">{{ errorDemandeMessage }}</span>
            </div>
          </div>
        </div>

        <div class="row justify-content-center mt-4">
          <div class="col-lg-4">
            <button @click="EnvoiDemandeUpdate" class="btn btn-orange w-100" id="send-demande">
              {{ $t("informations_personnelles.buttons.save") }}
            </button>
          </div>
        </div>
        <div v-if="successEnvoiDemandeMessage" class="alert alert-success mt-4 w-50 content-centered">
          <span class="success-message">{{ successEnvoiDemandeMessage }}</span>
        </div>
      </div>
    </template>
  </div>

  <div
    class="modal fade"
    id="ChangePasswordModal"
    ref="changePasswordModal"
    tabindex="-1"
    aria-labelledby="modalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-width">
      <div class="modal-content">
        <div class="modal-header justify-content-end">
          <button
            type="button"
            class="close-link"
            data-bs-dismiss="modal"
            :aria-label="$t('informations_personnelles.modals.close')"
          >
            <i class="ti ti-close"></i>
          </button>
        </div>
        <div class="modal-body padd-modal">
          <h3>{{ $t("informations_personnelles.modals.change_password_title") }}</h3>

          <form class="mt-4">
            <div class="d-flex gap-3">
              <div class="input-form">
                <label class="label-control">{{ $t("informations_personnelles.labels.current_password") }}</label>
                <input type="password" class="form-control" v-model="dataPassword.currentPassword" />
                <span v-if="errorCurrentPassword" class="error-message mb-4">{{ errorCurrentPassword }}</span>
              </div>
            </div>

            <div class="d-flex gap-3">
              <div class="input-form">
                <label class="label-control">{{ $t("informations_personnelles.labels.new_password") }}</label>
                <input type="password" class="form-control" v-model="dataPassword.newPassword" />
                <span v-if="errorNewPassword" class="error-message mb-4">{{ errorNewPassword }}</span>
              </div>
              <div class="input-form">
                <label class="label-control">{{ $t("informations_personnelles.labels.confirm_new_password") }}</label>
                <input type="password" class="form-control" v-model="dataPassword.confirmNewPassword" />
                <span v-if="errorConfirmNewPassword" class="error-message mb-4">{{ errorConfirmNewPassword }}</span>
              </div>
            </div>

            <div class="d-flex justify-content-center">
              <button class="btn btn-orange" @click.prevent="ConfirmChangePassword">
                {{ $t("informations_personnelles.buttons.edit") }}
                <span
                  v-if="isPasswordChangeLoading"
                  class="spinner-border spinner-border-sm me-1"
                  role="status"
                  aria-hidden="true"
                ></span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.input-group {
  display: flex;
  width: 100%;
  border: none !important;
}

.telephone-select {
  background-color: #e9ecef;
  border-right: none;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-color: #ced4da;
  max-width: 140px;
}

.telephone-select:focus {
  z-index: 2;
  border-color: #86b7fe;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.telephone-input {
  border-left: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-color: #ced4da;
}

.telephone-input:focus {
  z-index: 2;
  border-color: #86b7fe;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

/* Ensure the border between them looks seamless or handled correctly */
.telephone-select:not(:focus) + .telephone-input:not(:focus) {
  border-left: 1px solid #ced4da; 
}
</style>
<script>
  import { useRegisterStore } from "@/stores/register";
  import "bootstrap/dist/js/bootstrap.bundle.min.js";
  import { Modal } from "bootstrap";
  import { UpdatePassword, UpdateInfosPersonnelles } from "@/api/auth";
  import $ from "jquery";
  import { useToast } from "vue-toastification";
  import { COUNTRIES } from "@/config/constants";
  import { getCountryCallingCode, parsePhoneNumber } from "libphonenumber-js";

  export default {
    data() {
      return {
        mode: "simple",
        isPasswordChangeLoading: false,
        form: {
          sujet: "Demande de modification des informations personnelles",
          sujet_form: "modifinfopersonelle",
          message: "",
          channel: "/api/v2/shop/channels/supplyvet",

          update_billing_address: false,
          update_delivery_address: false,
          update_email: false,
          update_phone: false,
          update_lastname: false,
          update_firstname: false,
          update_clinic_name: false,

          update_billing_address_address: "",
          update_billing_address_address2: "",
          update_billing_address_address3: "",
          update_billing_address_postcode: "",
          update_billing_address_city: "",
          update_billing_address_pays: "",

          update_delivery_address_address: "",
          update_delivery_address_address2: "",
          update_delivery_address_address3: "",
          update_delivery_address_postcode: "",
          update_delivery_address_city: "",
          update_delivery_address_pays: "",

          update_email_email: "",
          update_phone_phone: "",
          indicatifPhoneNumber: "33",
          update_lastname_lastname: "",
          update_firstname_firstname: "",
          update_clinic_name_value: "",
        },
        registerStore: null,
        infos: {
          lastName: "",
          email: "",
        },
        dataPassword: {
          currentPassword: "",
          newPassword: "",
          confirmNewPassword: "",
        },
        isLoading: false,
        successEnvoiMessage: "",
        errorEnvoiMessage: "",
        errorCurrentPassword: "",
        errorNewPassword: "",
        errorConfirmNewPassword: "",
        HasValidate: true,

        errorDemandeAdressFacturation: "",
        errorDemandeCodePostalFacturation: "",
        errorDemandeVilleFacturation: "",
        errorDemandePaysFacturation: "",
        errorDemandeAdressLivraison: "",
        errorDemandeCodePostalLivraison: "",
        errorDemandeVilleLivraison: "",
        errorDemandePaysLivraison: "",
        errorDemandeEmail: "",
        errorDemandePhone: "",
        errorDemandeNom: "",
        errorDemandePrenom: "",
        errorDemandeNomClinique: "",
        errorDemandeMessage: "",
        canStoreDemande: true,
        isLoadingDemande: false,
        successEnvoiDemandeMessage: "",
      };
    },
    computed: {
      countryDialCodes() {
        return COUNTRIES.map((country) => {
          try {
            const dialCode = getCountryCallingCode(country.code);
            return {
              ...country,
              dialCode: dialCode,
              displayCode: `+${dialCode}`,
              displayName: `${country.name} (+${dialCode})`,
            };
          } catch (error) {
            return null;
          }
        })
        .filter((c) => c)
        .sort((a, b) => a.name.localeCompare(b.name));
      },
      parsedVeterinairePhone() {
        const phoneNumber = this.veterinaire?.phoneNumber;
        if (!phoneNumber) {
          return { indicatifPhoneNumber: "33", number: "" };
        }
        try {
          // Attempt to parse. Assume FR if no country code provided in string (e.g. 06...)
          const parsed = parsePhoneNumber(phoneNumber, 'FR');
          if (parsed) {
             return { 
               indicatifPhoneNumber: this.veterinaire?.indicatifPhoneNumber, 
               number: parsed.nationalNumber 
             };
          }
        } catch (error) {
          // Fallback
        }
        return { indicatifPhoneNumber: "33", number: phoneNumber };
      },
      veterinaire() {
        return this.registerStore.Veterinaire;
      },
      loading() {
        return this.registerStore.loading;
      },
    },
    mounted() {
      this.registerStore = useRegisterStore();
      this.registerStore.fetchVeterinaire();
    },
    created() {
      this.registerStore = useRegisterStore();
      var veterinaire_info = this.registerStore.VeterinaireInfo;
      const customer_infos = veterinaire_info?.customer_infos || {};
      const address_infos = veterinaire_info?.address_infos || {};
      this.infos = {
        id: customer_infos.id || null,
        lastName: customer_infos.lastName || "",
        email: customer_infos.email || "",
        phoneNumber: customer_infos.phoneNumber || "",
        street: address_infos.street || "",
        siret: customer_infos.siret || "",
      };
    },
    methods: {
      UpdateInfo() {
        if (this.HasValidate && this.dataPassword.newPassword != "") {
          this.isLoading = true;
          var spinner =
            '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Enregistrement en cours ...';
          $("#send").html(spinner);
          const customer_id = this.infos.id;
          UpdatePassword(customer_id, this.dataPassword)
            .then(res => {
              if (res) {
                this.successEnvoiMessage = "Votre mot de passe à été modifé avec succeé";
                setTimeout(() => {
                  this.successEnvoiMessage = "";
                }, 5000);
                $("#send").text("Enregistrer");
                this.isLoading = false;
              }
            })
            .catch(() => {
              this.isLoading = false;
              $("#send").text("Enregistrer");
              this.errorEnvoiMessage = "Une erreur s'est produite, vérifiez votre saisie.";
              setTimeout(() => {
                this.errorEnvoiMessage = "";
              }, 5000);
            });
        } else {
          this.errorEnvoiMessage = "Veuillez saisir le nouveau mot de passe";
          setTimeout(() => {
            this.errorEnvoiMessage = "";
          }, 5000);
        }
      },
      openChangePasswordModal() {
        const modalElement = this.$refs.changePasswordModal;
        const modalInstance = Modal.getOrCreateInstance(modalElement);
        this.dataPassword = {
          currentPassword: "",
          newPassword: "",
          confirmNewPassword: "",
        };
        modalInstance.show();
      },
      async ConfirmChangePassword() {
        const toast = useToast();

        this.errorCurrentPassword = "";
        this.errorNewPassword = "";
        this.errorConfirmNewPassword = "";
        this.HasValidate = true;

        this.CheckValidate();

        if (!this.HasValidate) {
          return;
        }
        this.isPasswordChangeLoading = true;

        try {
          const customer_id = this.infos.id;
          await UpdatePassword(customer_id, this.dataPassword);

          const modalElement = this.$refs.changePasswordModal;
          const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
          modalInstance.hide();

          toast.success("Votre mot de passe a été modifié avec succès.");

          this.dataPassword = {
            currentPassword: "",
            newPassword: "",
            confirmNewPassword: "",
          };
        } catch (error) {
          console.error("Erreur lors du changement de mot de passe:", error);
          let errorMessage = "Échec de la modification du mot de passe. Veuillez réessayer.";
          toast.error(errorMessage);
        } finally {
          this.isPasswordChangeLoading = false;
        }
      },
      CheckValidate() {
        if (this.dataPassword.currentPassword == "") {
          this.errorCurrentPassword = "Le champ mot de passe actuel est obligatoire";
          this.HasValidate = false;
        }

        if (this.dataPassword.newPassword == "") {
          this.errorNewPassword = "Le champ nouveau mot de passe est obligatoire";
          this.HasValidate = false;
        } else {
          if (this.dataPassword.newPassword != this.dataPassword.confirmNewPassword) {
            this.errorConfirmNewPassword =
              "nouveau mot de passe et confirmation nouveau mot de passe n'est pas identique";
            this.HasValidate = false;
          }
        }
      },
      /*************************Demande Update info personnel****************************/
      EnvoiDemandeUpdate() {
        this.errorDemandeAdressFacturation = "";
        this.errorDemandeCodePostalFacturation = "";
        this.errorDemandeVilleFacturation = "";
        this.errorDemandePaysFacturation = "";
        this.errorDemandeAdressLivraison = "";
        this.errorDemandeCodePostalLivraison = "";
        this.errorDemandeVilleLivraison = "";
        this.errorDemandePaysLivraison = "";
        this.errorDemandeEmail = "";
        this.errorDemandePhone = "";
        this.errorDemandeNom = "";
        this.errorDemandePrenom = "";
        this.errorDemandeMessage = "";
        this.canStoreDemande = true;
        this.isLoadingDemande = true;
        var spinner =
          '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Envoi demande en cours ...';
        $("#send-demande").html(spinner);
        this.CheckValidateDemande();
        if (this.canStoreDemande) {
          UpdateInfosPersonnelles(this.form)
            .then(res => {
              if (res.data && res.data.send) {
                this.ResetFormDemande();
                this.successEnvoiDemandeMessage = "Votre demande à été envoyé avec succeé";
                setTimeout(() => {
                  this.successEnvoiDemandeMessage = "";
                }, 5000);
              }
              $("#send-demande").text("Enregistrer");
              this.isLoadingDemande = false;
            })
            .catch(() => {
              this.isLoadingDemande = false;
              $("#send-demande").text("Enregistrer");
            });
        }
      },

      CheckValidateDemande() {
        if (this.form.update_billing_address) {
          if (this.form.update_billing_address_address == "") {
            this.errorDemandeAdressFacturation = "Le champ addresse de facturation est obligatoire";
            this.canStoreDemande = false;
          }
          if (this.form.update_billing_address_postcode == "") {
            this.errorDemandeCodePostalFacturation = "Le champ Code postal de facturation est obligatoire";
            this.canStoreDemande = false;
          }
          if (this.form.update_billing_address_city == "") {
            this.errorDemandeVilleFacturation = "Le champ ville de facturation est obligatoire";
            this.canStoreDemande = false;
          }
          if (this.form.update_billing_address_pays == "") {
            this.errorDemandePaysFacturation = "Le champ pays de facturation est obligatoire";
            this.canStoreDemande = false;
          }
        }

        if (this.form.update_delivery_address) {
          if (this.form.update_delivery_address_address == "") {
            this.errorDemandeAdressLivraison = "Le champ addresse de livraison est obligatoire";
            this.canStoreDemande = false;
          }
          if (this.form.update_delivery_address_postcode == "") {
            this.errorDemandeCodePostalLivraison = "Le champ Code postal de livraison est obligatoire";
            this.canStoreDemande = false;
          }
          if (this.form.update_delivery_address_city == "") {
            this.errorDemandeVilleLivraison = "Le champ ville de livraison est obligatoire";
            this.canStoreDemande = false;
          }
          if (this.form.update_delivery_address_pays == "") {
            this.errorDemandePaysLivraison = "Le champ pays de livraison est obligatoire";
            this.canStoreDemande = false;
          }
        }

        if (this.form.update_email) {
          if (this.form.update_email_email == "") {
            this.errorDemandeEmail = "Le champ email est obligatoire";
            this.canStoreDemande = false;
          } else {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!regex.test(this.form.update_email_email)) {
              this.errorDemandeEmail = "Format Email invalide";
              this.canStoreDemande = false;
            }
          }
        }

        if (this.form.update_phone && this.form.update_phone_phone == "") {
          this.errorDemandePhone = "Le champ téléphone fixe est obligatoire";
          this.canStoreDemande = false;
        }

        if (this.form.update_lastname && this.form.update_lastname_lastname == "") {
          this.errorDemandeNom = "Le champ nom est obligatoire";
          this.canStoreDemande = false;
        }

        if (this.form.update_firstname && this.form.update_firstname_firstname == "") {
          this.errorDemandePrenom = "Le champ prénom est obligatoire";
          this.canStoreDemande = false;
        }

        if (this.form.update_clinic_name && this.form.update_clinic_name_value == "") {
          this.errorDemandeNomClinique = "Le champ nom de la clinique est obligatoire";
          this.canStoreDemande = false;
        }

        if (this.form.message == "") {
          this.errorDemandeMessage = "Le champ message est obligatoire";
          this.canStoreDemande = false;
        }

        if (!this.canStoreDemande) {
          this.isLoadingDemande = false;
          $("#send-demande").text("Enregistrer");
        }
      },
      ResetFormDemande() {
        this.form = {
          sujet: "Demande de modification des informations personnelles",
          message: "",
          channel: "/api/v2/shop/channels/supplyvet",

          update_billing_address: false,
          update_delivery_address: false,
          update_email: false,
          update_phone: false,
          update_lastname: false,
          update_firstname: false,

          update_billing_address_address: "",
          update_billing_address_address2: "",
          update_billing_address_address3: "",
          update_billing_address_postcode: "",
          update_billing_address_city: "",
          update_billing_address_pays: "",

          update_delivery_address_address: "",
          update_delivery_address_address2: "",
          update_delivery_address_address3: "",
          update_delivery_address_postcode: "",
          update_delivery_address_city: "",
          update_delivery_address_pays: "",

          update_email_email: "",
          update_phone_phone: "",
          update_lastname_lastname: "",
          update_firstname_firstname: "",
        };
      },
    },
  };
</script>
